import { render } from "./zzsptfpjp.vue?vue&type=template&id=644f5d2a&scoped=true"
import script from "./zzsptfpjp.vue?vue&type=script&lang=js"
export * from "./zzsptfpjp.vue?vue&type=script&lang=js"

import "./zzsptfpjp.vue?vue&type=style&index=0&id=644f5d2a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f5d2a"]])

export default __exports__